var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStormy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "af5sd74gqes87f4e5s67f",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b85dg7s4df27se7f1ws25fqs",
    x1: 26.74,
    x2: 35.76,
    y1: 37.88,
    y2: 53.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7b23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f7b23b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#af5sd74gqes87f4e5s67f)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 00-19.11-8 7 7 0 00-10.57 6 7.21 7.21 0 00.1 1.14A7.5 7.5 0 0018 45.5a4.19 4.19 0 00.5 0v0h28a7 7 0 000-14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b85dg7s4df27se7f1ws25fqs)",
    stroke: "#f6a823",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M30 36l-4 12h4l-2 10 10-14h-6l4-8h-6z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "2s",
    repeatCount: "indefinite",
    values: "1; 1; 1; 1; 1; 1; 0.1; 1; 0.1; 1; 1; 0.1; 1; 0.1; 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormy);
export default __webpack_public_path__ + "static/media/stormy.537cfe07c3b42d165f535ea0ea1dd2e1.svg";
export { ForwardRef as ReactComponent };